import { DeviceInfo } from '@capacitor/device';

export class SetDeviceToken {
    public static readonly type = '[RootState] Set device token';

    constructor(public deviceToken: string, public deviceType: DeviceInfo['platform']) { }
}
